{
  "meta": {
    "title": "Entreprises",
    "manageAndSwitch": "Gérez et basculez entre vos entreprises"
  },
  "actions": {
    "import": "Importer",
    "createBusiness": "Créer une entreprise",
    "createBusinessOrInstitution": "Créer une entreprise ou institution",
    "createNewBusiness": "Créer une nouvelle entreprise",
    "switchTo": "Basculer vers",
    "back": "Retour",
    "backToBusinesses": "Retour aux entreprises",
    "actions": "Actions",
    "editBusiness": "Modifier l’entreprise",
    "deleteBusiness": "Supprimer l’entreprise",
    "cancel": "Annuler",
    "saveChanges": "Enregistrer",
    "saving": "Enregistrement",
    "uploadingImage": "Téléversement de l’image…",
    "makePrimary": "Définir comme principale",
    "makePrimaryConfirm": "Faire de cet emplacement le lieu principal de cette organisation ?",
    "makePrimarySuccess": "Lieu principal mis à jour",
    "makePrimaryError": "Échec de la mise à jour",
    "view": "Voir"
  },
  "empty": {
    "noBusinessesYet": "Aucune entreprise pour le moment",
    "createFirstOrImport": "Créez votre première entreprise ou importez-en plusieurs depuis Excel.",
    "selectFromList": "Sélectionnez une entreprise dans la liste",
    "clickToViewDetails": "Cliquez sur une entreprise pour voir ses détails",
    "searchNoMatch": "Aucune entreprise ne correspond à votre recherche"
  },
  "labels": {
    "unnamedBusiness": "Entreprise sans nom",
    "unnamed": "Sans nom",
    "branch": "Succursale",
    "primary": "Principale",
    "noDescription": "Aucune description",
    "noDescriptionAvailable": "Aucune description disponible",
    "contactAndLocation": "Contact et localisation",
    "quickLinks": "Liens rapides",
    "quickLinksDesc": "Gérez cette entreprise sur la plateforme",
    "businessProfile": "Profil de l’entreprise",
    "services": "Services",
    "appointments": "Rendez-vous",
    "income": "Revenus",
    "searchBusinessesPlaceholder": "Rechercher des entreprises…",
    "noContactInfo": "Aucune information de contact",
    "moreFromBusiness": "Plus de cet établissement",
    "moreFromBusinessDesc": "Autres emplacements liés à cette organisation"
  },
  "columns": {
    "name": "Entreprise",
    "industry": "Secteur",
    "location": "Localisation",
    "type": "Type"
  },
  "show": {
    "businessDetails": "Détails de l’entreprise",
    "businessNotFound": "Entreprise introuvable",
    "businessNotFoundDesc": "L’entreprise que vous recherchez n’existe pas ou a été supprimée.",
    "overview": "Aperçu",
    "analytics": "Analytique",
    "settings": "Paramètres",
    "createdOn": "Créée le {{date}}",
    "contactInfo": "Informations de contact",
    "contactInfoDesc": "Coordonnées et localisation",
    "email": "E-mail",
    "phone": "Téléphone",
    "location": "Adresse",
    "owner": "Propriétaire",
    "ownerDesc": "Informations sur le propriétaire",
    "financial": "Informations financières",
    "financialDesc": "Coordonnées bancaires pour les paiements",
    "bankName": "Nom de la banque",
    "accountNumber": "Numéro de compte",
    "fulfillmentRateTitle": "Taux d’exécution du service",
    "fulfillmentRateDesc": "Pourcentage de services complétés avec succès",
    "fulfillmentRate": "Taux d’exécution",
    "reportsTitle": "Signalements",
    "reportsDesc": "Nombre total de signalements reçus",
    "totalReports": "Total des signalements",
    "quickStats": "Statistiques rapides",
    "quickStatsDesc": "Aperçu des performances",
    "performance": "Performance",
    "status": "Statut",
    "industry": "Secteur",
    "active": "Actif",
    "blocked": "Bloqué",
    "businessSettings": "Paramètres de l’entreprise",
    "businessSettingsDesc": "Gérez la configuration et les préférences",
    "businessStatus": "Statut de l’entreprise",
    "currentStatus": "Statut actuel : {{status}}",
    "approvalStatus": "Statut d’approbation",
    "approvalState": "État d’approbation de l’entreprise",
    "editBusinessSettings": "Modifier les paramètres",
    "viewDetailsDesc": "Consultez les informations détaillées de cette entreprise"
  },
  "edit": {
    "title": "Modifier l’entreprise",
    "description": "Mettez à jour les informations de votre entreprise",
    "businessInformation": "Informations de l’entreprise",
    "businessInformationDesc": "Mettez à jour les détails de votre entreprise",
    "businessLogo": "Logo de l’entreprise",
    "businessName": "Nom de l’entreprise",
    "businessNamePlaceholder": "Saisir le nom de l’entreprise",
    "businessDescription": "Description de l’entreprise",
    "businessDescriptionPlaceholder": "Décrivez votre entreprise",
    "industry": "Secteur",
    "industryPlaceholder": "Sélectionner un secteur",
    "industrySearchPlaceholder": "Rechercher des secteurs…",
    "industryEmpty": "Aucun secteur trouvé",
    "businessEmail": "E-mail de l’entreprise",
    "businessEmailPlaceholder": "entreprise@exemple.com",
    "businessPhone": "Téléphone de l’entreprise",
    "businessPhonePlaceholder": "+1234567890",
    "locationRequired": "La localisation est requise",
    "updatedSuccess": "Entreprise mise à jour avec succès",
    "updateError": "Erreur lors de la mise à jour de l’entreprise",
    "location": "Adresse",
    "locationPlaceholder": "Rechercher une adresse"
  },
  "create": {
    "title": "Créer une entreprise ou institution",
    "branchTitle": "Ajouter un nouvel emplacement",
    "branchDescription": "Créer un autre emplacement lié à {{name}}.",
    "chooseType": {
      "title": "Que souhaitez-vous créer ?",
      "description": "Choisissez s’il s’agit d’une entreprise autonome ou d’une succursale d’une entreprise existante.",
      "standaloneTitle": "Entreprise autonome",
      "standaloneDescription": "Une entreprise distincte avec sa propre organisation.",
      "branchTitle": "Succursale / emplacement",
      "branchDescription": "Un nouvel emplacement lié à {{name}}.",
      "branchDescriptionFallback": "Un nouvel emplacement lié à votre entreprise actuelle.",
      "cancel": "Annuler"
    },
    "descriptionPrefix": "Suivez les étapes ci-dessous pour créer votre entreprise ou institution. Besoin d’en ajouter plusieurs ?",
    "importViaExcel": "Importer via Excel",
    "steps": {
      "infoTitle": "Informations entreprise ou institution",
      "infoDesc": "Saisissez les informations de base",
      "locationTitle": "Localisation et contact",
      "locationDesc": "Ajoutez l’adresse et les coordonnées",
      "planTitle": "Choisir un forfait",
      "planDesc": "Sélectionnez Starter ou Premium pour votre entreprise",
      "documentsTitle": "Documents",
      "documentsDesc": "Téléversez les documents requis"
    },
    "toasts": {
      "uploadFailedPrefix": "Échec du téléversement :",
      "uploadDocFailed": "Impossible de téléverser le document. Veuillez réessayer.",
      "uploadImageFailed": "Impossible de téléverser l’image. Veuillez réessayer.",
      "createdSuccess": "Entreprise ou institution créée avec succès",
      "createError": "Erreur lors de la création",
      "fillAllRequired": "Veuillez remplir tous les champs obligatoires",
      "coordsNotFound": "Coordonnées introuvables pour cette adresse. Choisissez une suggestion ou vérifiez l’adresse.",
      "uploadRequiredDoc": "Veuillez téléverser le document requis",
      "locationDenied": "Accès à la localisation refusé ou indisponible"
    },
    "next": {
      "next": "Suivant",
      "nextWithTitle": "Suivant : {{title}}"
    }
  },
  "createSteps": {
    "ownerEmail": "E-mail du propriétaire (entreprise ou institution)",
    "ownerEmailPlaceholder": "proprietaire@exemple.com",
    "logo": "Logo de l’entreprise ou institution",
    "name": "Nom de l’entreprise ou institution",
    "namePlaceholder": "Saisir le nom",
    "description": "Description de l’entreprise ou institution",
    "descriptionPlaceholder": "Décrivez votre entreprise ou institution",
    "industry": "Secteur",
    "industryPlaceholder": "Sélectionner un secteur",
    "industrySearchPlaceholder": "Rechercher des secteurs…",
    "industryEmpty": "Aucun secteur trouvé",
    "whereLocated": "Où se situe votre entreprise ou institution ?",
    "location": "Adresse",
    "locationHelp": "Commencez à taper votre adresse et choisissez une suggestion pour définir votre localisation exacte.",
    "locationPlaceholder": "ex. 123 Main Street, Accra",
    "contactHeader": "Comment pouvons-nous vous contacter ?",
    "email": "E-mail (entreprise ou institution)",
    "phone": "Téléphone (entreprise ou institution)",
    "documents": {
      "requirements": "Exigences :",
      "pdfOnly": "Doit être au format PDF",
      "singlePdf": "Téléversez tous les documents en un seul PDF",
      "registrationDocs": "Doit contenir les documents d’enregistrement et d’incorporation",
      "ids": "Doit contenir la Ghana Card ou le passeport de deux directeurs",
      "documentLabel": "Document de l’entreprise ou institution"
    },
    "locationPermission": {
      "allowTitle": "Autoriser l’accès à la localisation ?",
      "failedTitle": "Échec de l’accès à la localisation",
      "autoFillDesc": "Nous pouvons pré-remplir votre adresse pour accélérer la configuration. Vous pourrez toujours la modifier manuellement.",
      "tryAgainOrManual": "Vous pouvez réessayer ou saisir l’adresse manuellement.",
      "enterManually": "Saisir manuellement",
      "tryAgain": "Réessayer",
      "allowLocation": "Autoriser",
      "detecting": "Détection de la localisation…"
    }
  },
  "import": {
    "title": "Importer des entreprises",
    "description": "Importez des entreprises en masse via un modèle Excel",
    "templateDownloaded": "Modèle téléchargé",
    "instructions": "Instructions",
    "downloadTemplate": "Télécharger le modèle",
    "downloadTemplateHelp": "Téléchargez le modèle Excel et renseignez vos données selon les en-têtes de colonnes.",
    "downloadTemplateBtn": "Télécharger le modèle",
    "uploadFilledTemplate": "Téléverser le modèle rempli",
    "uploadFilledTemplateHelp": "Téléversez votre fichier Excel complété pour importer en masse.",
    "foundCount": "{{count}} entreprise{{plural}} trouvée{{plural}}",
    "importing": "Importation…",
    "importBtn": "Importer des entreprises",
    "parseNone": "Aucune ligne valide trouvée. Assurez-vous que le fichier contient une ligne d’en-têtes et au moins une entreprise avec un nom et un téléphone.",
    "parseFailed": "Impossible d’analyser le fichier Excel. Veuillez vérifier le format.",
    "selectFileFirst": "Veuillez d’abord sélectionner un fichier",
    "noValidBusinesses": "Aucune entreprise valide. Chaque ligne doit contenir un nom et un téléphone.",
    "importedSuccess": "Entreprises importées avec succès",
    "importFailed": "Échec de l’importation des entreprises",
    "requiredColumnsTitle": "Colonnes requises",
    "requiredColumnsDesc": "Votre fichier Excel doit inclure ces colonnes :",
    "required": {
      "name": "Nom (5–150 caractères)",
      "phone": "Téléphone",
      "optional": "Optionnel : description, secteur, e-mail, adresse, image, document, latitude, longitude, parentBusiness (id d’entreprise existante)"
    }
  },
  "dialogs": {
    "createBusinessDialog": {
      "title": "Créez votre entreprise ou institution",
      "description": "Pour utiliser pleinement le système et accéder à toutes les fonctionnalités (services, rendez-vous, gestion des revenus, etc.), vous devez d’abord créer une entreprise ou institution.",
      "dontShowAgain": "Ne plus afficher",
      "dismiss": "Fermer"
    }
  }
}
